export default __webpack_public_path__ + "static/media/t18.min.d3ce0b42.png";